import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { FeedbackConstant } from "./FeedbackConstant";

const initialState = {
    FeedbackList: [],
    FeedbackDataLoading: {
    isLoading: false,
  },
};

export const FeedbackReducer = persistReducer(
  {
    storage,
    key: "FeedbackData",
    whitelist: [" FeedbackList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case FeedbackConstant.FEEDBACK_REQUEST: {
        return {
          ...state,
          FeedbackList: [],
          FeedbackDataLoading: {
            isLoading: true,
          },
        };
      }

      case FeedbackConstant.FEEDBACK_RESPONSE: {
        return {
          ...state,
          FeedbackList: payload,
          FeedbackDataLoading: {
            isLoading: false,
          },
        };
      }
     default:
        return state;
    }
  }
);
